import { baseCrudFactory } from "~/stores/base.crud.store"
import { Api } from "~/api/Api"
import { useProjetStore, useInterventionPlanningStore } from "~/stores"
import { InterventionModel } from "~/model"
import type { InterventionPlanningResource } from "~/api/models/InterventionPlanningResource"

export const useInterventionStore = baseCrudFactory({
    endpoint: "interventions",
    primaryKey: "IDINTERVENTION",
    title: "intervention",
    startDateKey: "RDV_DEBUT",
    endDateKey: "RDV_FIN",
    showDelete: false,
    model: InterventionModel,
    modules: {
        projet: () => useProjetStore(),
        intervention_planning: () => useInterventionPlanningStore(),
    },
    actions: {
        async fetchTeamIntervention(params) {
            return await Api.equipe.equipeLocalisationPersonnelIntervention(
                params,
            )
        },
        async finaliseInterventionGood(idIntervention, payload) {
            const response =
                await Api.interventionFeedback.interventionFeedbackFinaliseGood(
                    idIntervention,
                    payload,
                )
            this.setItems(response)
        },
        async finaliseInterventionBad(idIntervention, payload) {
            const response =
                await Api.interventionFeedback.interventionFeedbackFinaliseBad(
                    idIntervention,
                    payload,
                )
            // this.setItems(response.new_intervention)
        },
        /**
         * Récupère les réclamations SAV planifiées (dernier mois par défaut)
         */
        async fetchNonPlanifiees(): Promise<InterventionPlanningResource[]> {
            const response =
                await Api.intervention.interventionGetNonPlanifiees()
            this.setItems(response)
        },
        /**
         * Prendre en charge une réclamation SAV
         * @param idIntervention - ID de l'intervention
         */
        async prendreEnCharge(
            idIntervention,
        ): Promise<InterventionPlanningResource> {
            const response =
                await Api.intervention.interventionPrendreEnCharge(
                    idIntervention,
                )
            this.setItem(response)
        },
    },
    getters: {
        reclamations() {
            return this.items
                .filter((intervention) => {
                    return intervention.isReclamationSav === true
                })
                .sort((a, b) => {
                    return (b.IDINTERVENTION || 0) - (a.IDINTERVENTION || 0)
                })
        },
    },
})
